import { Skeleton } from 'shared/ui/skeleton';
export const TariffSelectorSkeleton = () => {
  return <div className="flex-2 w-full" data-sentry-component="TariffSelectorSkeleton" data-sentry-source-file="tariff-selector skeleton.tsx">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-10 w-full" variant="dark" data-sentry-element="Skeleton" data-sentry-source-file="tariff-selector skeleton.tsx" />
        <Skeleton className="h-2 w-full" variant="dark" data-sentry-element="Skeleton" data-sentry-source-file="tariff-selector skeleton.tsx" />
      </div>
    </div>;
};